// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1r0_U","resendInfoText":"OnGoingPaymentBox_resendInfoText__2X8OF"};